var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialYoutube = function SvgSocialYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 15 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.846 2.272S14.7 1.244 14.249.783c-.57-.596-1.211-.6-1.502-.636C10.649 0 7.493 0 7.493 0S4.345 0 2.246.153C1.953.188 1.314.192.744.788c-.451.454-.595 1.49-.595 1.49A23 23 0 0 0 0 4.704v1.138q.01 1.22.15 2.428S.295 9.3.743 9.761c.57.595 1.32.577 1.657.64 1.2.115 5.099.149 5.099.149s3.153 0 5.25-.156c.293-.034.932-.038 1.503-.634.45-.454.598-1.489.598-1.489q.138-1.21.149-2.43v-1.14a24 24 0 0 0-.152-2.43z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.946 7.216V3.001l4.05 2.116z",
    clipRule: "evenodd"
  })));
};
export default SvgSocialYoutube;